import React from 'react';
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';
import PropTypes from 'prop-types';

const MapView = ({
  coordinates,
  isChange = false,
  setCoordinates,
  editStationId,
  isReadOnly,
}) => {
  const defaultCoordinates = [23.0117639, 72.5095528];
  const [lng, lat] = coordinates || defaultCoordinates;

  const center = { lat, lng };

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ['places'],
  });

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={{ height: '400px', width: '100%' }}
      center={center}
      zoom={15}
      onClick={(event) => {
        if (isChange && !editStationId && !isReadOnly) {
          setCoordinates({
            lng: event.latLng.lng(),
            lat: event.latLng.lat(),
          });
        }
      }}
      options={{
        draggable: !editStationId || !isReadOnly,
        zoomControl: !editStationId,
        scrollwheel: !editStationId,
        disableDoubleClickZoom: editStationId,
        gestureHandling: editStationId ? 'none' : 'auto',
      }}
    >
      <Marker
        position={center}
        draggable={isChange && !editStationId && !isReadOnly}
        onDragEnd={(event) => {
          if (isChange && !editStationId && !isReadOnly) {
            setCoordinates({
              lng: event.latLng.lng(),
              lat: event.latLng.lat(),
            });
          }
        }}
      />
    </GoogleMap>
  ) : (
    <></>
  );
};

MapView.propTypes = {
  coordinates: PropTypes.shape({
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
  }).isRequired,
  isChange: PropTypes.bool.isRequired,
  setCoordinates: PropTypes.func,
  editStationId: PropTypes.string,
  isReadOnly: PropTypes.bool,
};

export default MapView;
